var _style, _path, _circle, _g, _rect, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHormones({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A384F;}\n\t.st1{fill:#EFC260;}\n\t.st2{fill:#F08F65;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7S86,4,56.6,4S3.5,27.6,3.5,56.7S27.3,109.4,56.6,109.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50.6,
    cy: 25.7,
    r: 4.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.1,75.9 59.1,75.9 55.1,82.8 59.1,89.7 67.1,89.7 71,82.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 64.2,
    className: "st1",
    width: 3.4,
    height: 14
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.8,
    y: 25.9,
    transform: "matrix(0.8774 -0.4798 0.4798 0.8774 -9.1108 30.1669)",
    className: "st1",
    width: 3.4,
    height: 14
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.3,82C25.9,82,19,75.1,19,66.7s6.9-15.3,15.3-15.3s15.3,6.9,15.3,15.3S42.8,82,34.3,82z M45.3,66.7 c0-6.1-4.9-11-11-11s-11,4.9-11,11s4.9,11,11,11S45.3,72.7,45.3,66.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8,
    y: 50,
    transform: "matrix(0.5048 0.8632 -0.8632 0.5048 75.2043 -17.0739)",
    className: "st2",
    width: 3.4,
    height: 14
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.7,71.5c-11.1,0-20.1-9-20.1-20.1s9-20.1,20.1-20.1s20.1,9,20.1,20.1S78.8,71.5,67.7,71.5z M75.8,37.6h-3.6 l-1.8,3.1l1.8,3.1h3.6l1.8-3.1L75.8,37.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHormones);
export default __webpack_public_path__ + "static/media/Hormones.4bf0ee220533df3ce4ecd24b28121017.svg";
export { ForwardRef as ReactComponent };